/**
 * StatusBadge Component
 *
 * Shared colored badge for transaction status.
 */

import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const statusColorMap: Record<string, string> = {
  settlement: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  success: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  pending: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  expire: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  cancel: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  deny: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const color = statusColorMap[status.toLowerCase()] ?? "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
        color,
        className
      )}
    >
      {status}
    </span>
  );
}
